import { useTranslation } from 'react-i18next';

import { Bell, Heart, Zap } from 'lucide-react';

import { CardIcon } from '@components/card';
import { CTA } from '@components/cta';
import { Typography } from '@components/typography';

import { isMobileDevice } from '@globalUtils/environment';

export function IntroSection() {
  const { t } = useTranslation();

  return (
    <div className="w-full flex flex-col items-center gap-[5vh] lg:gap-[10vh]">
      <div className="flex w-full flex-wrap lg:flex-nowrap justify-between items-center gap-4 lg:gap-0">
        <div className="w-full lg:w-[56%] shrink-0 flex flex-col items-center lg:items-start">
          <Typography className="w-full" variant="titlesmall">
            {t('introtitle')}
          </Typography>
          {!isMobileDevice() && <CTA className="mt-[3vh] lg:mt-[5vh]" data-id="boton-10" />}
        </div>

        <div className="w-full lg:grow flex flex-col items-center lg:items-start">
          <Typography className="w-full" variant="base">
            {t('introdescription')}
          </Typography>
          {isMobileDevice() && <CTA className="mt-[3vh] lg:mt-[5vh]" data-id="boton-11" />}
        </div>
      </div>
      <div className="flex w-full justify-between gap-8 lg:gap-4 flex-wrap lg:flex-nowrap">
        <CardIcon
          title={t('introcard1title')}
          description={t('introcard1description')}
          iconImg={<Zap size={60} strokeWidth={2} className="text-white" />}
        />
        <CardIcon
          title={t('introcard2title')}
          description={t('introcard2description')}
          iconImg={<Bell size={60} strokeWidth={2} className="relative z-50 text-white" />}
        />
        <CardIcon
          title={t('introcard3title')}
          description={t('introcard3description')}
          iconImg={<Heart size={60} strokeWidth={2} className="text-white" />}
        />
      </div>
    </div>
  );
}
